"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    materialSymbolsUrl: ()=>materialSymbolsUrl
});
const external_validGoogleSymbols_cjs_namespaceObject = require("./validGoogleSymbols.cjs");
const validGoogleSymbolsClone = [
    ...external_validGoogleSymbols_cjs_namespaceObject.validGoogleSymbols
];
const googleSymbols = validGoogleSymbolsClone.sort().join(',');
const materialSymbolsUrl = `https://fonts.googleapis.com/css2?family=Material+Symbols+Rounded:opsz,wght,FILL,GRAD@24,400,0..1,0&display=block&icon_names=${googleSymbols}`;
exports.materialSymbolsUrl = __webpack_exports__.materialSymbolsUrl;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "materialSymbolsUrl"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
